import type { StandardSchemaV1 } from "@tanstack/react-form";

import {
	createChangePasswordSchemaBase,
	type ChangePasswordFormValuesBase,
} from "@/features/auth/changePasswordSchema";
import type { PasswordStrengthValidation } from "@/features/auth/passwordStrengthValidation";

export type ChangeUserPasswordFormValues = ChangePasswordFormValuesBase;

/**
 * The schema is handed to TanStack Form as a Standard Schema, so
 * no error-shape adapter is needed — issues are mapped onto fields by `path`.
 *
 * The cast is owed to `strictNullChecks: false`: `undefined extends boolean | null` holds, so
 * Zod infers `disconnectMobileDevices` as optional, which no longer matches the required keys
 * of `ChangeUserPasswordFormValues`. Runtime validation is unaffected.
 */
export function createChangeUserPasswordSchema(
	hasConnectedMobileDevices: boolean,
	passwordStrengthValidation?: PasswordStrengthValidation,
): StandardSchemaV1<ChangeUserPasswordFormValues> {
	return createChangePasswordSchemaBase(
		hasConnectedMobileDevices,
		passwordStrengthValidation,
	) as StandardSchemaV1<ChangeUserPasswordFormValues>;
}
